import { Plus } from "lucide-react";

export const ProductCard = ({ product, onAddToCart }) => (
  <div className="product-card bg-white rounded-xl overflow-hidden border border-gray-100" data-testid={`product-card-${product.id}`}>
    <div className="aspect-square overflow-hidden bg-gray-100">
      <img 
        src={product.image_url} 
        alt={product.name}
        className="w-full h-full object-cover"
      />
    </div>
    <div className="p-6">
      <span className="text-xs uppercase tracking-wider text-celebration-red font-medium">{product.category}</span>
      <h3 className="font-serif text-xl mt-1">{product.name}</h3>
      <p className="text-gray-600 text-sm mt-2 whitespace-pre-line">{product.description}</p>
      <div className="flex items-center justify-between mt-4 pt-4 border-t">
        <span className="text-celebration-red font-bold text-xl">
          ${product.price.toFixed(2)}
          <span className="text-sm font-normal text-gray-500 ml-1">/{product.price_unit}</span>
        </span>
        <button 
          onClick={() => onAddToCart(product, product.min_quantity)}
          className="btn-primary px-5 py-3 text-sm"
          data-testid={`add-${product.id}`}
        >
          <Plus className="w-4 h-4 inline mr-1" />
          Add to Cart
        </button>
      </div>
    </div>
  </div>
);
